import { render } from "./FormSeparata.vue?vue&type=template&id=a3e099e0&scoped=true"
import script from "./FormSeparata.vue?vue&type=script&lang=js"
export * from "./FormSeparata.vue?vue&type=script&lang=js"

import "./FormSeparata.vue?vue&type=style&index=0&id=a3e099e0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a3e099e0"

export default script